import React, { Component } from 'react';
import { connect } from 'react-redux';
import withModal from '../../../../lib/hoc/withModal';
import { appActions } from '../../../../store/modules/app';
import ReturnExchangeReasonModal from '../../../../views/app/common/modal/ReturnExchangeReasonModal';

class ReturnExchangeReasonModalContainer extends Component {
  /**
   * 모달 닫기 || 데이터 초기화
   */
  closeModal = () => {
    const { appToggleModal } = this.props;
    appToggleModal({
      name: 'returnExchangeReasonModal',
    });
  };

  render() {
    const { isOpen, data } = this.props;

    return <ReturnExchangeReasonModal isOpen={isOpen} data={data} closeModal={this.closeModal} />;
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.app.returnExchangeReasonModal.isOpen,
    data: state.app.returnExchangeReasonModal.data,
  };
};

const mapDispatchToProps = {
  appToggleModal: appActions.appToggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(ReturnExchangeReasonModalContainer));
